/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 27.04.2016.
 */
import LoginForm from './login-form';

export default LoginForm;



// WEBPACK FOOTER //
// ./src/containers/LoginForm/index.js